"use client"
import React, { useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

// --- IMPORT THE CSS MODULE
import styles from './tabSliderStyles.module.css';

// import required modules
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';

export default function TabSliderStyles({ images }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  // 1. Filter out null, undefined, or empty string images
  const validImages = images ? images.filter(image => image) : [];

  if (validImages.length === 0) {
    return null;
  }

  return (
    // We use responsive viewport height (vh) limits instead of aspect ratio
    // so the entire slider (main image + thumbs) fits on the screen at one glance without scrolling.
    <div className={`${styles.tabSliderWrapper} w-full h-[60vh] md:h-[75vh] max-h-[800px] min-h-[400px]`}>
      {/* Main Swiper */}
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }}
        loop={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className={styles.mySwiper2}
      >
        {validImages.map((image, index) => (
          <SwiperSlide key={index}>
            <img src={image} alt={`Image ${index + 1}`} loading="lazy" />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Thumbnail Swiper */}
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={true}
        spaceBetween={10}
        slidesPerView={Math.min(validImages.length, 4)} 
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className={styles.mySwiper}
      >
        {validImages.map((image, index) => (
          <SwiperSlide key={index}>
            <img src={image} alt={`Thumbnail ${index + 1}`} loading="lazy" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
